import ReconnectingWebSocket from 'reconnecting-websocket';
import { WS_URL } from './config';

const connectToRoom = (roomId, uuid, onOpen, onMessage) => {
  const socket = new ReconnectingWebSocket(`${WS_URL}/ws/${roomId}`);

  socket.onopen = () => {
    // console.log(`Connected to room ${roomId}`);
    socket.send(`register::${uuid}`);

    onOpen && onOpen();
  };

  socket.onmessage = (event) => {
    // console.log(`Received message in room ${roomId}:`, event.data);
    let data = event.data;

    try {
      data = JSON.parse(data);
    } catch (error) {}

    onMessage && onMessage(data);
  };

  return socket;
}

const sendMessage = (socket, uuid, username, data) => {
  if (socket.readyState === WebSocket.OPEN) {
    if (typeof data === 'string') {
      socket.send(JSON.stringify({ type: 'message', uuid, username, message: data }));
    } else {
      socket.send(JSON.stringify({ uuid, username, ...data }));
    }
  } else {
    console.warn('WebSocket is not open. Message not sent.');
  }
}

const closeSocket = (socket) => {
  socket.close();
}

export {
  connectToRoom,
  sendMessage,
  closeSocket,
};
